import { Search, Zap } from "lucide-react";

const COPY = {
  standard: "Inizia inserendo una parola chiave qui sopra. I risultati appariranno qui, curati secondo i tuoi parametri.",
  live: 'Esplora i lotti che stanno chiudendo l\'asta proprio ora su Catawiki. Premi "Cerca live" per vedere chi sta per battere il martelletto.',
};

export default function WelcomeState({ mode }) {
  const Icon = mode === "live" ? Zap : Search;
  const iconColor = mode === "live" ? "text-gold/70" : "text-white/20";
  return (
    <div className="text-center py-20" data-testid="welcome-state">
      <Icon className={`w-10 h-10 mx-auto ${iconColor} mb-6`} />
      <p className="text-white/40 font-light max-w-md mx-auto">{COPY[mode]}</p>
    </div>
  );
}
